import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Restaumatic$dCart$dCart from "../Restaumatic.Cart.Cart/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
const $$$Error = (tag, _1) => ({tag, _1});
const $Mode = tag => ({tag});
const CartMode = /* #__PURE__ */ $Mode("CartMode");
const DeliveryMode = /* #__PURE__ */ $Mode("DeliveryMode");
const MinOrderValueWarning = value0 => $$$Error("MinOrderValueWarning", value0);
const MaxOrderValueWarning = value0 => $$$Error("MaxOrderValueWarning", value0);
const UnavailableDishes = value0 => $$$Error("UnavailableDishes", value0);
const OrderingNotPossible = /* #__PURE__ */ $$$Error("OrderingNotPossible");
const NotOverlappingDishes = /* #__PURE__ */ $$$Error("NotOverlappingDishes");
const nullOutput = {
  itemCount: /* #__PURE__ */ (() => {
    const n = Specular$dInternal$dIncremental.constant(0);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  })(),
  canOrder: /* #__PURE__ */ (() => {
    const n = Specular$dInternal$dIncremental.constant(false);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  })(),
  grandTotal: /* #__PURE__ */ (() => {
    const n = Specular$dInternal$dIncremental.constant(0);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  })(),
  cart: /* #__PURE__ */ (() => {
    const n = Specular$dInternal$dIncremental.constant(Restaumatic$dCart$dCart.empty);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  })(),
  deliveryMethod: /* #__PURE__ */ (() => {
    const n = Specular$dInternal$dIncremental.constant(Data$dMaybe.Nothing);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  })(),
  submit: Specular$dFRP$dBase.never
};
const fromRawThemeSettings = v => (
  {
    cartDishImages: v.cart_dish_images,
    dishImageStyle: v.dish_image_style,
    cartModalImage: v.cart_modal_image,
    menuSplitPizzaImage: v.menu_split_pizza_image,
    menuCreatorImage: v.menu_creator_image,
    menuGroupPizzaPieChoiceClasses: v.menu_group_pizza_pie_choice_classes
  }
);
const emptyThemeSettings = {
  cartDishImages: Data$dMaybe.Nothing,
  dishImageStyle: Data$dMaybe.Nothing,
  cartModalImage: Data$dMaybe.Nothing,
  menuSplitPizzaImage: Data$dMaybe.Nothing,
  menuCreatorImage: Data$dMaybe.Nothing,
  menuGroupPizzaPieChoiceClasses: Data$dMaybe.Nothing
};
export {
  $$$Error,
  $Mode,
  CartMode,
  DeliveryMode,
  MaxOrderValueWarning,
  MinOrderValueWarning,
  NotOverlappingDishes,
  OrderingNotPossible,
  UnavailableDishes,
  emptyThemeSettings,
  fromRawThemeSettings,
  nullOutput
};
